export default {
  Username: 'Username',
  Cedula: 'Identification card:',
  LastModification: ' Last modification:',
  ChangePassword: 'Change Password',
  ChangePrimaryEmail: 'Change Primary Email',
  modifypassword: 'Modify password',
  Currentpassword: 'Current password',
  Password: 'Password',
  NewPassword: 'New Password',
  Repeatnewpassword: 'Repeat new password',
  CONFIRM: 'CONFIRM',
  Contactinformation: 'Contact information',
  Modify_email: 'Modify email',
  Current_email: 'Current email',
  New_email: ' New email',
  Repeat_new_email: ' Repeat new email',
  Address: 'Address',
  Province: 'Province',
  Municipality: 'Municipality',
  Sector: 'Sector',
  Mobile_phone: ' Mobile phone',
  Residential_telephone: '  Residential telephone',
  Work_phone: 'Work phone',
  Secondary_email: 'Secondary email',
  Notification_Preferences: '  Notification Preferences',
  Email: 'Email',
  My_settings: 'My settings',
  save: 'Save'






}